import { getRouterAdapter } from '../utils';

type Location<State = any> = {
  pathname: string;
  search?: string;
  hash?: string;
  state?: State;
  key?: string;
};

/**
 * Wrapper around react-router-dom's useLocation hook that returns a
 * Location object with a generic type.
 *
 * @deprecated use `useLocation` instead.
 */
export const useLocationLegacy = <State = any>() =>
  getRouterAdapter().useLocation() as Location<State>;
